import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinkharadipune() {



  const cardData = {
"keyword": "Bus On Rent in Kharadi Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Bus on Rent in Kharadi, Pune for corporate travel, IT company staff transportation, weddings, school trips, airport transfers, and group sightseeing. Our fleet includes well-maintained AC and Non-AC buses in multiple seating capacities such as 20, 25, 32, 40, and 50-seaters. With experienced drivers, doorstep pickup in Kharadi and nearby areas like EON IT Park and World Trade Center, we ensure safe, punctual, and comfortable group travel across Pune and outstation routes.",

"topPlaces": [
    
    {
      "title": "Mahabaleshwar",
      "description": "Mahabaleshwar is a famous hill station known for strawberries, viewpoints, and cool weather, ideal for group tours and family trips."
    },
    {
      "title": "Panchgani",
      "description": "Panchgani is a peaceful hill station near Mahabaleshwar known for scenic valleys, table land, and relaxing group travel experiences."
    },
    {
      "title": "Shirdi",
      "description": "Shirdi is a major pilgrimage destination dedicated to Sai Baba, widely visited by families and religious groups from Pune."
    },
    {
      "title": "Nashik",
      "description": "Nashik is known for its vineyards, temples, and religious importance, making it a popular outstation travel route from Pune."
    },
    {
      "title": "Lonavala",
      "description": "Lonavala is a popular hill station near Pune known for its green valleys, waterfalls, and weekend getaways. It is one of the most common outstation travel destinations."
    },
    {
      "title": "Khandala",
      "description": "Khandala is a scenic hill station close to Pune famous for mountain views, monsoon beauty, and short family trips."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal beach destination near Pune famous for beaches, resorts, and weekend group tours."
    },
    {
      "title": "Goa",
      "description": "Goa is India’s top beach destination known for nightlife, beaches, and long-distance group tours from Pune."
    },
    {
      "title": "Lavasa",
      "description": "Lavasa is a planned hill city near Pune known for its scenic lakeside view and short leisure trips."
    }
  ],



services: [
  {
    name: "Urbania Bus on Rent in Kharadi",
    description: "Urbania bus on rent in Kharadi service provides premium transportation for airport transfers, corporate travel, family vacations, sightseeing journeys, and outstation trips. Spacious luxury interiors and comfortable seating ensure smooth travel experiences suitable for business and leisure travel. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial areas across Kharadi Pune. Flexible booking options allow convenient Urbania bus reservations."
  },
  {
    name: "17 Seater Bus on Rent Per KM in Kharadi",
    description: "17 seater bus on rent per km in Kharadi service offers flexible and affordable transportation for local travel, office outings, airport transfers, educational tours, and family journeys. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, IT parks, and commercial locations across Kharadi Pune. Flexible booking options allow convenient per km bus reservations."
  },
  {
    name: "Tempo Traveller on Rent in Kharadi",
    description: "Tempo Traveller on rent in Kharadi service provides comfortable transportation for sightseeing tours, airport pickups, corporate travel, family outings, and outstation journeys. Spacious seating and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, IT parks, and commercial areas across Kharadi Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Bus on Rent in Wagholi Pune for Outstation",
    description: "Bus on rent in Wagholi Pune for outstation service offers dependable long-distance transportation for Goa tours, pilgrimage journeys, family vacations, and sightseeing travel. Spacious buses and comfortable seating ensure smooth highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Wagholi Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "Wedding Bus on Rent in Wagholi",
    description: "Wedding bus on rent in Wagholi service provides reliable transportation for bridal parties, wedding guests, family members, and marriage event travel requirements. Spacious seating and smooth travel performance ensure comfortable journeys suitable for wedding ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, and residential areas across Wagholi Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Bus Hire in Kharadi IT Park",
    description: "Bus hire in Kharadi IT Park service offers professional transportation for employee movement, office outings, conferences, business meetings, and corporate travel requirements. Spacious buses and comfortable seating ensure smooth journeys suitable for IT professionals and office teams. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Kharadi Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "14 17 20 25 Seater Bus on Rent in Kharadi",
    description: "14 17 20 25 seater bus on rent in Kharadi service provides multiple seating options for family tours, educational trips, office outings, airport transfers, and sightseeing journeys. Spacious buses ensure comfortable travel experiences suitable for small and medium-sized passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, and commercial locations across Kharadi Pune. Flexible booking options allow convenient seater bus reservations."
  },
  {
    name: "32 35 40 45 50 Seater Bus on Rent in Kharadi",
    description: "32 35 40 45 50 seater bus on rent in Kharadi service offers spacious transportation for weddings, school trips, corporate events, pilgrimage journeys, and tourist travel. Comfortable seating and luggage space ensure smooth highway journeys suitable for large passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, railway stations, and airports across Kharadi Pune. Flexible booking options allow convenient large bus reservations."
  },
  {
    name: "Corporate Bus Hire Kharadi",
    description: "Corporate bus hire Kharadi service provides dependable transportation for employee travel, business meetings, conferences, industrial visits, and executive journeys. Spacious buses and smooth travel performance ensure comfortable experiences suitable for office teams and corporate passengers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Kharadi Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "Bus Hire for IT Companies Kharadi",
    description: "Bus hire for IT companies Kharadi service offers professional transportation for employee movement, office shuttle services, team outings, conferences, and business travel. Spacious buses and comfortable interiors ensure smooth journeys suitable for IT professionals and office groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Kharadi Pune. Flexible booking options allow convenient IT company bus reservations."
  },
  {
    name: "Airport Pickup Bus Kharadi",
    description: "Airport pickup bus Kharadi service provides reliable transportation for tourists, corporate guests, wedding groups, and family passengers traveling to and from airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for all passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, and Pune Airport terminals across Kharadi Pune. Flexible booking options allow convenient airport bus reservations."
  },
  {
    name: "Bus Hire for Wedding Kharadi",
    description: "Bus hire for wedding Kharadi service offers comfortable transportation for bridal parties, wedding guests, family gatherings, and marriage event travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding ceremonies and celebrations. Professional drivers ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, and residential areas across Kharadi Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Bus Hire for Family Trip Kharadi",
    description: "Bus hire for family trip Kharadi service provides dependable transportation for holiday vacations, sightseeing journeys, pilgrimage tours, and group travel with relatives and family members. Spacious interiors and comfortable seating ensure smooth travel experiences suitable for local and outstation family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Kharadi Pune. Flexible booking options allow convenient family trip bus reservations."
  },
  {
    name: "Bus Hire for Group Tour Kharadi",
    description: "Bus hire for group tour Kharadi service offers spacious transportation for educational tours, tourist travel, office outings, sightseeing journeys, and pilgrimage trips. Comfortable seating and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, railway stations, and airports across Kharadi Pune. Flexible booking options allow convenient group tour bus reservations."
  },
  {
    name: "Luxury Bus Hire Kharadi",
    description: "Luxury bus hire Kharadi service provides premium transportation for weddings, corporate events, airport transfers, family vacations, and sightseeing tours. Spacious luxury interiors and elegant seating ensure smooth travel experiences suitable for executive passengers and tourist groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, railway stations, and airports across Kharadi Pune. Flexible booking options allow convenient luxury bus reservations."
  },
  {
    name: "AC Bus Hire Kharadi",
    description: "AC bus hire Kharadi service offers premium air-conditioned transportation for corporate travel, family trips, educational tours, airport transfers, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, railway stations, and airports across Kharadi Pune. Flexible booking options allow convenient AC bus reservations."
  },
  {
    name: "Non AC Bus Hire Kharadi",
    description: "Non AC bus hire Kharadi service provides affordable transportation for educational tours, local sightseeing, office outings, school trips, and group journeys. Spacious seating and smooth travel ensure comfortable experiences suitable for budget-friendly travel requirements. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, schools, offices, hotels, IT parks, and airports across Kharadi Pune. Flexible booking options allow convenient non AC bus reservations."
  },
  {
    name: "Bus Hire Wagholi",
    description: "Bus hire Wagholi service offers dependable transportation for weddings, airport transfers, family outings, educational tours, and outstation journeys from Wagholi Pune. Spacious buses and comfortable seating ensure smooth travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Wagholi Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "Bus Hire Viman Nagar Nearby",
    description: "Bus hire Viman Nagar nearby service provides reliable transportation for airport travel, office outings, sightseeing journeys, educational tours, and family functions. Spacious seating and luggage capacity ensure comfortable journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, Pune Airport, and commercial areas across Viman Nagar Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "Bus Hire Hadapsar Nearby",
    description: "Bus hire Hadapsar nearby service offers comfortable transportation for weddings, corporate travel, family outings, airport transfers, and sightseeing journeys from Hadapsar Pune. Spacious buses and smooth travel performance ensure pleasant experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient bus hire reservations."
  }
],

tableData: [
  ["Urbania Bus on Rent in Kharadi", "17 Seater Bus on Rent Per KM in Kharadi"],
  ["Tempo Traveller on Rent in Kharadi", "Bus on Rent in Wagholi Pune for Outstation"],
  ["Wedding Bus on Rent in Wagholi", "Bus Hire in Kharadi IT Park"],
  ["14 17 20 25 Seater Bus on Rent in Kharadi", "32 35 40 45 50 Seater Bus on Rent in Kharadi"],
  ["Corporate Bus Hire Kharadi", "Bus Hire for IT Companies Kharadi"],
  ["Airport Pickup Bus Kharadi", "Bus Hire for Wedding Kharadi"],
  ["Bus Hire for Family Trip Kharadi", "Bus Hire for Group Tour Kharadi"],
  ["Luxury Bus Hire Kharadi", "AC Bus Hire Kharadi"],
  ["Non AC Bus Hire Kharadi", "Bus Hire Wagholi"],
  ["Bus Hire Viman Nagar Nearby", "Bus Hire Hadapsar Nearby"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Bus On Rent in Kharadi Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable bus rental service in Kharadi Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate travel, family tours, and group transportation."
      },
      {
        WhyChooseheading: "Affordable Bus Rental Packages in Kharadi",
        WhyChoosedescription: "Aaradhya Travels offers affordable bus on rent in Kharadi Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Bus Booking Service in Kharadi Pune",
        WhyChoosedescription: "Our bus rental service in Kharadi Pune operates 24 hours for airport transfers, employee transportation, weddings, school trips, corporate outings, and outstation group travel."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC Bus Options",
        WhyChoosedescription: "All buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for safe and comfortable travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, pilgrimage journeys, office outings, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose from 20 seater, 25 seater, 32 seater, 35 seater, 45 seater, and 50 seater buses suitable for family groups, corporate teams, schools, and tourists."
      },
      {
        WhyChooseheading: "Quick Pickup Service in Kharadi & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Kharadi, EON IT Park, World Trade Center, Magarpatta, Viman Nagar, Hadapsar, Wagholi, and Pune Airport for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Group Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is bus on rent in Kharadi Pune?", answer: "Bus rental service in Kharadi Pune provides comfortable group transportation for corporate travel, family tours, school trips, weddings, and outstation journeys." },
    { question: "Is bus booking available 24 hours in Kharadi Pune?", answer: "Yes, Aaradhya Travels provides 24/7 bus rental service in Kharadi Pune." },
    { question: "Which seating capacity buses are available?", answer: "Aaradhya Travels offers 20 seater, 25 seater, 32 seater, 35 seater, 45 seater, and 50 seater buses for group travel requirements." },
    { question: "Can I book buses for outstation travel from Kharadi?", answer: "Yes, customers can book buses for outstation tours, hill station trips, pilgrimage journeys, and holiday travel from Kharadi Pune." },
    { question: "Do you provide buses for corporate events in Kharadi?", answer: "Yes, Aaradhya Travels provides bus rental service for corporate meetings, office outings, conferences, and employee transportation in Kharadi." },
    { question: "Are AC and Non-AC buses available?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC buses for comfortable and budget-friendly group travel." },
    { question: "Can I book bus rental service online in Kharadi Pune?", answer: "Yes, customers can easily book bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and family functions?", answer: "Yes, Aaradhya Travels provides spacious buses suitable for weddings, family vacations, and group events." },
    { question: "Are bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for bus rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul More",
    feedback:
      "We arranged a bus on rent in Kharadi Pune for our office team outing and the experience was very smooth. The vehicle was clean, comfortable, and arrived on time, making our travel hassle-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "A bus rental in Kharadi Pune helped us manage transportation for a family function easily. The journey was comfortable, and the service was well-coordinated from start to finish.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Kharadi Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/bus-on-rent-in-kharadi-pune.jpg",
  "description": "Book Bus on rent in Kharadi Pune with Aaradhya Travels for corporate travel, IT company transport, airport transfers, weddings, family trips, and outstation tours. Available in Urbania, tempo traveller, AC, Non-AC, and luxury buses from 14 to 50 seater.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3765"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/bus-on-rent-in-kharadi-pune"
  }
};





  return (
    <div>


<Helmet>
  <title>
    Bus On Rent in Kharadi Pune | IT Company & Corporate Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Bus on rent in Kharadi Pune with Aaradhya Travels. Premium Urbania, tempo traveller, AC and Non-AC buses available for IT companies, corporate travel, weddings, airport pickup, family trips, Wagholi, Viman Nagar, and outstation tours."
  />

  <meta
    name="keywords"
    content="Urbania bus on rent in Kharadi, 17 Seater bus on rent per km in Kharadi, Tempo traveller on rent in Kharadi, Bus on rent in Wagholi Pune for outstation, Wedding bus on rent in Wagholi, Bus hire in Kharadi IT Park, 14 17 20 25 Seater bus on rent in Kharadi, 32 35 40 45 50 Seater bus on rent in Kharadi, Corporate bus hire Kharadi, Bus hire for IT companies Kharadi, Airport pickup bus Kharadi, Bus hire for wedding Kharadi, Bus hire for family trip Kharadi, Bus hire for group tour Kharadi, Luxury bus hire Kharadi, AC bus hire Kharadi, Non AC bus hire Kharadi, Bus hire Wagholi, Bus hire Viman Nagar nearby"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinkharadipune;